import Alpine from 'alpinejs'

export default (function () {
  Alpine.data('scrollProgress', function () {
    let elem = null
    return {
      progress: 0,
      get reachedFinalPosition() {
        return this.progress >= 1
      },
      init() {
        elem = this.$el
        this.updateProgress()
        window.addEventListener('scroll', this.updateProgress.bind(this), true)
      },
      updateProgress() {
        const viewportMiddle = window.scrollY + (window.innerHeight / 2)
        const rect = elem.getBoundingClientRect()
        const elemTop = rect.top + window.scrollY
        const elemBottom = elemTop + rect.height
        const raw = (viewportMiddle - elemTop) / (elemBottom - elemTop)
        this.progress = Math.max(0, Math.min(1, raw))
      },
    }
  })
})()